<!-- <h1>app-web-viewer-frame works!</h1> -->
<iframe id="webViewerFrame" [src]="urlSafe" allowfullscreen></iframe>